import * as React from "react";
const SvgFiRrCustard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23 17h-.838L20.141 5.544A5.49 5.49 0 0 0 14.725 1H9.276a5.495 5.495 0 0 0-5.417 4.544L1.837 17H1a1 1 0 1 0 0 2h.051c.252 2.244 2.139 4 4.449 4h13c2.31 0 4.197-1.756 4.449-4H23a1 1 0 1 0 0-2M5.457 8H6.5C7.327 8 8 8.673 8 9.5V14a1 1 0 1 0 2 0V9.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V12a1 1 0 1 0 2 0V9.5c0-.827.673-1.5 1.5-1.5h2.044l1.588 9H3.868zm3.819-5h5.449a3.496 3.496 0 0 1 3.447 2.892l.019.108H16.5c-.979 0-1.864.403-2.5 1.053a3.49 3.49 0 0 0-5 0A3.5 3.5 0 0 0 6.5 6h-.69l.019-.108A3.496 3.496 0 0 1 9.276 3m9.225 18H5.5a2.5 2.5 0 0 1-2.449-2H20.95a2.5 2.5 0 0 1-2.449 2"
    />
  </svg>
);
export default SvgFiRrCustard;
